import { render, staticRenderFns } from "./userAgreement.vue?vue&type=template&id=16f7769e&scoped=true&"
import script from "./userAgreement.vue?vue&type=script&lang=js&"
export * from "./userAgreement.vue?vue&type=script&lang=js&"
import style0 from "./userAgreement.vue?vue&type=style&index=0&id=16f7769e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f7769e",
  null
  
)

export default component.exports